import styled from 'styled-components'
import { Flex } from '@mantine/core'

export const FundingFilterStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;

  .mantine-GateTabs-tabsList {
    overflow: auto;
    flex-wrap: nowrap;
    overflow-x: scroll;
    width: calc(100% - 36px);

    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      background: hsla(215, 17%, 59%, 0.2);
    }
    &::-webkit-scrollbar-track {
      border-radius: 0px;
    }
  }

  .gui-mantine-rtl-GateTabs-tabsList {
    justify-content: flex-end !important;
  }
`

export const FundingFilterFooterStyled = styled.div`
  display: flex;
  height: 76px;
  align-items: center;
  width: 100%;
`

export const FundingFilterRoundsStyled = styled.div`
  height: calc(80vh - 184px);
  overflow-y: auto;

  &[data-investors='true'] {
    height: calc(80vh - 184px - 24px);
  }
`

export const FundingFilterRoundsBoxStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

export const FundingFilterRoundsItemStyled = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 120%;
  color: var(--color-text-2);
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-divider-5);
  border-radius: 6px;
  text-align: center;

  &[data-focus='true'] {
    border: 1px solid var(--color-brand-3);
    color: var(--color-text-5);
  }
`

export const FundingFilterCustomFlexStyled = styled(Flex)`
  border-top: 1px var(--color-divider-2) solid;
  padding-top: 24px;
  margin-top: 24px;
`
